import { AttedanceDetailComponent } from './presensi-detail.component';
export default AttedanceDetailComponent;
